export default (function(context,factory){

	return factory();

})(window,function(){

	/**
	 * @desc Base64共用库
	 * @exports qt/base64
	 * @version 1.0.0
	 * @author maixingjie
	 * @copyright Copyright 2017-2027
	 * 
	 */

	/*
	 * UCS-2编码(16进制) UTF-8 字节流(二进制)
	 * 0000 - 007F 0xxxxxxx
	 * 0080 - 07FF 110xxxxx 10xxxxxx
	 * 0800 - FFFF 1110xxxx 10xxxxxx 10xxxxxx
	 */

	var BASE64_MAPPING = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

	/**
	 * @desc 把字符对象转换成Byte数组
	 * @param {String} str unicode字符串
	 * @return {Array} 返回Byte数组(只取最低8位)
	 */
	function unicodeToByte(str){
		var byteArray = new Array();
		for(var i=0,len=str.length;i<len;i++){
			var unicode = str.charCodeAt(i);
			if(unicode < 0x80){
				//UTF-8 1byte
				byteArray.push(unicode);
			}else if(unicode >= 0x80 && unicode <= 0x7FF){
				//UTF-8 2byte
				byteArray.push(unicode>>6 | 0xC0);
				byteArray.push(unicode & 0x3F | 0x80);
			}else if(unicode >= 0x800 && unicode <= 0xFFFF){
				//UTF-8 3byte
				byteArray.push(unicode>>12 & 0xF | 0xE0);
				byteArray.push(unicode>>6 &0x3F | 0x80);
				byteArray.push(unicode &0x3F | 0x80);
			}
		}
		return byteArray;
	}


	/**
	 * @desc 将base64字符串换成Byte数组
	 * @param {String} str base64字符串
	 * @return {Array} 返回Byte数组(只取最低8位)
	 */
	function base64ToByte(str){
		var _str = str.replace(/==$/,'AA');
		_str = _str.replace(/=$/,'A');

		var index1 = 0;
		var index2 = 0;
		var index3 = 0;
		var index4 = 0;
		var buffer = 0;
		var bytes = new Array();
		for(var i=0,len=_str.length;i<len;i+=4){
			index1 = BASE64_MAPPING.indexOf(_str[i]);
			index2 = BASE64_MAPPING.indexOf(_str[i+1]);
			index3 = BASE64_MAPPING.indexOf(_str[i+2]);
			index4 = BASE64_MAPPING.indexOf(_str[i+3]);

			buffer = (index1<<18) + (index2<<12) + (index3<<6) + index4;
			bytes.push(buffer>>16);
			bytes.push(buffer>>8 & 0xFF);
			bytes.push(buffer & 0xFF);
		}
		if(/==$/.test(str)){
			bytes.pop();
			bytes.pop();
		}else if(/=$/.test(str)){
			bytes.pop();
		}
		return bytes;
	}


	var _BASE64 = {
		/**
		 * @desc base64编码
		 * @param {String} str unicode字符串
		 * @return {String} base64字符串
		 */
		encode : function(str){
			//获取字节
			var bytes = unicodeToByte(str);

			//补够3的整数，以便3bytes转成4个base64块
			var rest = bytes.length%3;
			if(1 == rest){
				bytes.push(0,0);
			}else if(2 == rest){
				bytes.push(0);
			}

			var result = new Array();
			var buffer;
			//开始每3位转换
			for(var i=0,len=bytes.length;i<len;i+=3){
				buffer=(bytes[i]<<16)+(bytes[i+1]<<8)+bytes[i+2];
				result.push(BASE64_MAPPING.charAt(buffer>>18));
				result.push(BASE64_MAPPING.charAt(buffer>>12&0x3f));
				result.push(BASE64_MAPPING.charAt(buffer>>6&0x3f));
				result.push(BASE64_MAPPING.charAt(buffer&0x3f));
			}
			var rtn = result.join('');
			if(1==rest){
				rtn = rtn.replace(/AA$/,'==');
			}
			if(2==rest){
				rtn = rtn.replace(/A$/,'=');
			}
			return rtn;
		},

		/**
		 * @desc base64解码
		 * @param {String} str base64字符串
		 * @return {String} unicode字符串
		 */
		decode : function(str){
			var bytes = base64ToByte(str);

			var _byte;
			var unicode;
			var rtn = new Array();
			for(var i=0,len=bytes.length;i<len;i++){
				_byte = bytes[i];
				if(_byte >= 0xE0){
					//UTF-8 3byte
					unicode = ((bytes[i] & 0xF)<<12) + ((bytes[i+1] & 0x3F)<<6) + (bytes[i+2] & 0x3F);
					i+=2;
				}else if(_byte >= 0xC0){
					//UTF-8 2byte
					unicode = ((bytes[i] & 0x1F)<<6) + (bytes[i+2] & 0x3F);
					i+=1;
				}else if(_byte <= 0x80){
					//UTF-8 1byte
					unicode = (bytes[i] & 0x7F);
				}
				rtn.push(String.fromCharCode(unicode));
			}
			return rtn.join('');
		}
	}

	return _BASE64;
});



// WEBPACK FOOTER //
// ./src/libs/qt/base64.js